export default "__VITE_ASSET__C_hte8xa__"